import React from "react";

const CookiesPolicy = () => (
  <div
    className="container"
    style={{
      padding: "0.85rem 0.6rem",
      maxWidth: 380,
      background: "#ffffff",
      borderRadius: 12,
      boxShadow: "0 1px 6px #cab38a14",
      margin: "18px auto"
    }}
  >
    <h1 style={{
      fontSize: "1.05rem",
      marginBottom: 7,
      fontWeight: 700,
      letterSpacing: '.025em',
      color: "#2c2c2c"
    }}>
      Cookies Policy
    </h1>
    <p style={{ fontSize: ".88em", color: "#888", marginBottom: 7 }}>Last Updated: November 13, 2025</p>
    <p style={{ fontSize: ".93em", marginBottom: 9 }}>
      This Cookies Policy explains what cookies are, how Zoteya Beauty Salon (“we”, “us”, or “our”) uses them on this website, and your choices regarding cookies.
    </p>
    <h2 style={{ fontSize: ".98rem", fontWeight: 700, marginTop: 13, marginBottom: 6, color: "#a07817" }}>What Are Cookies?</h2>
    <p style={{ fontSize: ".93em", marginBottom: 9 }}>
      Cookies are small text files stored on your device when you visit our website. Cookies help the site function correctly and provide us with information about how visitors interact with our website.
    </p>
    <h2 style={{ fontSize: ".98rem", fontWeight: 700, marginTop: 13, marginBottom: 6, color: "#a07817" }}>How We Use Cookies</h2>
    <ul style={{ marginBottom: 10, fontSize: ".93em", paddingLeft: "18px" }}>
      <li><strong>Essential Cookies:</strong> Required for the website to work properly (e.g. shopping cart, checkout).</li>
      <li><strong>Performance Cookies:</strong> Collect data on how visitors use our website to help us improve functionality and user experience.</li>
      <li><strong>Preference Cookies:</strong> Remember your settings and preferences (like cookie consent).</li>
    </ul>
    <h2 style={{ fontSize: ".98rem", fontWeight: 700, marginTop: 13, marginBottom: 6, color: "#a07817" }}>Your Choices</h2>
    <p style={{ fontSize: ".93em", marginBottom: 9 }}>
      By continuing to use our website, you agree to our use of cookies. You may remove or block cookies through your browser settings at any time, but parts of our site may not work properly if you do.
    </p>
    <h2 style={{ fontSize: ".98rem", fontWeight: 700, marginTop: 13, marginBottom: 6, color: "#a07817" }}>Who Controls Cookies on Our Website?</h2>
    <p style={{ fontSize: ".93em", marginBottom: 9 }}>
      Cookies on this site are set and controlled by Zoteya Beauty Salon and our trusted third-party partners (for analytics or payment processing). For a full explanation of how we use your data, view our <a href="/privacy-policy" style={{ color: "#b8860b", textDecoration: "underline" }}>Privacy Policy</a>.
    </p>
    <h2 style={{ fontSize: ".98rem", fontWeight: 700, marginTop: 13, marginBottom: 6, color: "#a07817" }}>Contact</h2>
    <p style={{ fontSize: ".93em", marginBottom: 9 }}>
      For questions about this Cookies Policy, please email us at <a href="mailto:info@zoteya.com" style={{ textDecoration: "underline" }}>info@zoteya.com</a>.
    </p>
    <h2 style={{ fontSize: ".98rem", fontWeight: 700, marginTop: 13, marginBottom: 6, color: "#a07817" }}>Website Provider</h2>
    <p style={{ fontSize: ".93em" }}>
      This website was designed and developed by Webwizards Pty Ltd.
    </p>
  </div>
);

export default CookiesPolicy;
